import React from "react";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { useStyles, PurchaseResumeInfo } from "./style";
import CurrencyFormat from "../../utils/currencyFormat";
import { language } from "../../utils/language";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/index";
import { wasShippingFree } from "../../utils/shippingRules";

export const TablePdfPaymentDetail = (props: any) => {
	const homeState: HomeStateType = useSelector(
		(state: RootState) => state.home
	);
	const classes = useStyles();
	const purchase = props.props.purchase;
	const shippingWasFree = wasShippingFree({
		totalPaid: purchase.totalAmount,
		subtotal: props.subTotal,
		taxes: purchase.taxAmountTotal + purchase.consumptionTaxAmountTotal,
		couponDiscount: purchase.detailTotal?.discountCode ?? 0,
		shippingCost: purchase.shippingCost ?? 0,
	});
	return (
		<div>
			<Table>
				<TableRow>
					<TableCell style={{ borderBottom: "none" }}>
						<div className={classes.paymentDetail}>
							<PurchaseResumeInfo>
								<div>
								<div>{language[homeState.default_language]["subtotal"]} {((props.props.purchase.taxAmountTotal !== 0 || props.props.purchase.consumptionTaxAmountTotal !== 0 ) ? " + "+language[homeState.default_language]["tax"]: "")}</div>
								<div>
										<CurrencyFormat amount={props.subTotal + ((props.props.purchase.taxAmountTotal !== 0 || props.props.purchase.consumptionTaxAmountTotal !== 0 ) ? props.props.purchase.taxAmountTotal + props.props.purchase.consumptionTaxAmountTotal : 0)} />

									</div>
								</div>

								<div>
									<div>
										{language[homeState.default_language]["cost"]}{" "}
										{language[homeState.default_language]["send"]}
									</div>
									<div>
										{shippingWasFree ? (
											language[homeState.default_language]["free"]
										) : (
											<CurrencyFormat
												amount={props.props.purchase.shippingCost}
											/>
										)}
									</div>
								</div>

								{props.props.purchase.detailTotal.discountCode !== 0 && <>
									<div>
										<div>{language[homeState.default_language]["discount"]}</div>
										<div>
											<CurrencyFormat amount={props.props.purchase.detailTotal.discountCode} />
										</div>
									</div>
								</>}


								{props.props.delivery && (
									<>
										<div>
											<div>{language[homeState.default_language]["send"]} {props.props.shipping["472"].operador}</div>
											<div>{language[homeState.default_language]["free2"]}</div>
										</div>
									</>
								)}
								{props.props.shipping["tcc"].costo_total != 0 && (
									<>
										<div>
											<div>{language[homeState.default_language]["send"]} {props.props.shipping["tcc"].operador}</div>
											<div>
												<CurrencyFormat
													amount={props.props.shipping["tcc"].costo_total}
												/>
											</div>
										</div>
									</>
								)}

								{props.props.shipping["472"].costo_total != 0 && (
									<>
										<div>
											<div>{language[homeState.default_language]["send"]} 4-72</div>
											<div>
												<CurrencyFormat
													amount={props.props.shipping["472"].costo_total}
												/>
											</div>
										</div>
									</>
								)}

								<div id="last">
                                    <div>{language[homeState.default_language]["total"]}</div>
									<div>
										<CurrencyFormat amount={Math.abs(props.payment)} />
									</div>
								</div>
							</PurchaseResumeInfo>
						</div>
					</TableCell>
				</TableRow>
			</Table>
		</div>
	);
};
